import { motion } from "framer-motion";
import { Hourglass } from "lucide-react";

function PageHeader() {
  return (
    <section className="bg-[#FAFAFA] pt-40 pb-20 border-b border-black/5">
      <div className="container-saksham">
        <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="text-xs md:text-sm uppercase tracking-[0.3em] text-[#09B792] font-semibold mb-6">
          Our Impact
        </motion.p>
        <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.1 }} className="font-serif text-6xl md:text-7xl lg:text-8xl leading-[0.98] tracking-tight font-medium max-w-5xl">
          Stories, lessons, and <em className="text-[#09B792] not-italic">small revolutions.</em>
        </motion.h1>
        <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.25 }} className="mt-8 max-w-2xl text-base md:text-lg text-[#4A4A4A] leading-relaxed">
          A growing library of field notes, scheme explainers, and micropreneur journeys — from across India.
        </motion.p>
      </div>
    </section>
  );
}

export default function OurImpact() {
  return (
    <div data-testid="page-our-impact">
      <PageHeader />
      <section className="bg-[#FAFAFA] section-y">
        <div className="container-saksham">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            data-testid="coming-soon"
            className="bg-white border border-black/5 py-24 md:py-32 px-6 text-center relative overflow-hidden"
          >
            <div className="absolute inset-0 bg-grain opacity-30 pointer-events-none" />
            <div className="relative">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-[#FBD223] mb-8">
                <Hourglass className="text-[#0A0A0A]" size={24} />
              </div>
              <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-[#09B792] font-semibold mb-4">
                In the Works
              </p>
              <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight font-medium">
                Coming <em className="text-[#09B792] not-italic">Soon.</em>
              </h2>
              <p className="mt-6 max-w-lg mx-auto text-[#4A4A4A] text-base md:text-lg leading-relaxed">
                We're gathering stories from the field. Check back shortly — or drop us a note if you have one to share.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
